import SlsWebLogger from 'js-sls-logger'
const host = "cn-shanghai.log.aliyuncs.com";
const project = "fp-zl-device";
const logstore_pro = "fp-business-pro";
const logstore_test = "fp-business-test";


const opts_dev = {
    host: host,      
    project: project,                 
    logstore: logstore_test,               
    time: 1, 
    count: 1, 
}
const opts_pro = {
    host: host,      
    project: project,                 
    logstore: logstore_pro,               
    time: 1, 
    count: 10, 
}
const logger_dev = new SlsWebLogger(opts_dev)
const logger_pro = new SlsWebLogger(opts_pro)

export const fplogger = {
    sendLog(data,flag){
        if(flag == 'dev'){
            logger_dev.send(data);
        }
        else{
            logger_pro.send(data)
        }

    }
}
